var _module_exports = "<div ng-if=\"$ctrl.hasDomain\" class=\"sf-automation-login-page-corp-logo\">\n    <div class=\"splunk-corp-logo floating\"></div>\n</div>";;
var path = '/builds/observability/imm/signalview/src/legacy/common/security/login/corpFloatingLogo.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;